module.exports = __webpack_public_path__ + "src/assets/img/share/tips/nervousness/86eb5af8a6dddeb48a34f3aae65101a9.png";